var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"my-2",attrs:{"align":"center"}},[_c('v-divider'),_c('span',{staticClass:"px-2 font-weight-medium grey--text"},[_vm._t("default")],2),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }